import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../../types";
import { getApi } from "../../../apiPath";
import { axiosClient } from "../../../clients";

import type { ILaboratoryStudents } from "./routeType";

const { key, getPath } = getApi("members.laboratories.students.getAll");

type IExtractedRouteType =
  ILaboratoryStudents["laboratoryStudentCollectionRetrieve"];

export type IGetAllMemberLaboratoryStudents =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberLaboratoryStudents: Fetcher<
  IGetAllMemberLaboratoryStudents["response"],
  IGetAllMemberLaboratoryStudents["variables"]
> = ({ labId, ...params }) => {
  return axiosClient.get(getPath({ labId }), { params });
};

export const useGetAllMemberLaboratoryStudents = createQuery({
  queryKey: [key],
  fetcher: getAllMemberLaboratoryStudents,
});
